import { Descriptions, Space, Tag, Typography } from "antd";
import { useMemo } from "react";
const { Text } = Typography;

const ApplicantsDetails = ({ data }) => {
  function yesNo(v) {
    return v ? "Yes" : "No";
  }

  const interestedProducts = useMemo(() => {
    const defs = [
      ["home_option_checkbox", "Home"],
      ["marine_option_checkbox", "Marine"],
      ["hangar_option_checkbox", "Hangar"],
      ["business_option_checkbox", "Business"],
    ];
    return defs.filter(([key]) => data[key]).map(([, label]) => label);
  }, [data]);

  return (
    <Descriptions bordered size="small" column={2}>
      <Descriptions.Item label="Named Insured" span={2}>
        {data.main_owner_name || "-"}
      </Descriptions.Item>

      {data.additional_owner_names?.length ? (
        <Descriptions.Item label="Additional Owners" span={2}>
          <Space wrap>
            {data.additional_owner_names.map((n, i) => (
              <Tag key={`${n}-${i}`}>{n}</Tag>
            ))}
          </Space>
        </Descriptions.Item>
      ) : null}

      <Descriptions.Item label="Contact Person">
        {data.contact_person || "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Occupation">
        {data.occupation || "-"}
      </Descriptions.Item>

      <Descriptions.Item label="Email">
        <Text>{data.email || "-"}</Text>
      </Descriptions.Item>
      <Descriptions.Item label="Phone(s)">
        {Array.isArray(data.phone_numbers) && data.phone_numbers.length ? (
          <Space direction="vertical" size={0}>
            {data.phone_numbers.map((p, idx) => (
              <Text key={idx}>
                {p.type ? <Text strong>{p.type}:</Text> : null}{" "}
                {p.number || "-"}
              </Text>
            ))}
          </Space>
        ) : (
          "-"
        )}
      </Descriptions.Item>

      <Descriptions.Item label="Address" span={2}>
        {[data.address, data.city, data.province, data.postal_code]
          .filter(Boolean)
          .join(", ") || "-"}
      </Descriptions.Item>

      <Descriptions.Item label="Currently Insured">
        {yesNo(data.currently_insured)}
      </Descriptions.Item>
      <Descriptions.Item label="Other Insurance in Place">
        {yesNo(data.has_other_insurance)}
      </Descriptions.Item>

      <Descriptions.Item label="Other Insurance Carrier">
        {data.other_insurance_carrier || "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Referral Reason">
        {data.referral_reason || "-"}
      </Descriptions.Item>

      <Descriptions.Item label="Interested Products" span={2}>
        {interestedProducts.length ? (
          <Space wrap>
            {interestedProducts.map((t) => (
              <Tag key={t}>{t}</Tag>
            ))}
          </Space>
        ) : (
          <Text type="secondary">None indicated</Text>
        )}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default ApplicantsDetails;
